import React from "react";
import Footer from "../../organisms/Footer/Footer";
import Banner from "../../molecules/HomeBanner/HomeBanner";
import Features from "../../molecules/HomeFeatures/HomeFeatures";
import DownloadApp from "../../molecules/HomeDownloadApp/HomeDownloadApp";
import Testimonial from "../../molecules/HomeTestimonial/HomeTestimonial";
import Newsletter from "../../molecules/HomeNewsletter/HomeNewsletter";
import Navigation from "../../organisms/Navigation/Navigation";
const LandingPage = () => {
  return (
    <div>
    <Navigation />
      <Banner />
      <Features />
      <DownloadApp />
      <Testimonial />
      <Newsletter />
      <Footer />
    </div>
  );
};

export default LandingPage;
